import { Inject, Injectable, Optional, SkipSelf } from "@angular/core";

import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';

import { LigneModelePlanMaintenance } from './ligne-modele-plan-maintenance.entity';

@Injectable({ providedIn: 'root' })
export class LigneModelePlanMaintenanceService {
	private path: string;

	constructor( //
		@Inject(HttpClient) private httpClient: HttpClient, //
		@Optional() @SkipSelf() previousInstance?: LigneModelePlanMaintenanceService //
	) {
		if (previousInstance) {
			throw new Error(
				'This service is already loaded. Import it in the AppModule only');
		}
		this.path = (window as any).baseApiPath;
	}

	public getLignesByModele(modeleId: number): Observable<LigneModelePlanMaintenance[]> {
		let url = this.path + "modele-plan-maintenance/" + modeleId + "/lignes?format=DTO";
		let result = this.httpClient //
			.get<LigneModelePlanMaintenance[]>(url) //
		;

		return result;
	}
}